export const WAIST_CATEGORIES = ["men-pants", "men-joggers", "mens-trousers"];
